import { mergeTemplate } from './base-template';

export const treuhandPrivateTemplate = mergeTemplate({
  name: 'Treuhand für Privatpersonen (HNWI)',
  icon: '🛡️',
  settings: {
    primaryColor: '#111827',
    accentColor: '#b8860b',
    fontStack: 'serif',
    stylePreset: 'editorial',
    designDensity: 'airy',
    pageAngebot: {
      heroTitle: 'Unsere Leistungen für Privatpersonen',
      heroSubtitle: 'Individuelle Betreuung auf höchstem Niveau',
      packages: [
        { name: 'Vermögensverwaltung', price: 'auf Anfrage', description: 'Ganzheitliche Betreuung Ihres Vermögens', features: 'Steueroptimierung, Anlageberatung, Strukturierung, Reporting', highlighted: false },
        { name: 'Nachlassplanung', price: "ab CHF 5'000", description: 'Vorausschauende Regelung Ihres Nachlasses', features: 'Erbschaftsplanung, Testamentsvollstreckung, Stiftungsgründung, Familienrecht', highlighted: true },
        { name: 'Steueroptimierung', price: 'auf Anfrage', description: 'Legale Minimierung Ihrer Steuerlast', features: 'Steuererklärung, Rulings, Wegzugsplanung, Vorsorge-Optimierung', highlighted: false },
      ],
      ctaTitle: 'Diskretion und Kompetenz',
      ctaText: 'Vereinbaren Sie ein vertrauliches Gespräch — persönlich oder an einem Ort Ihrer Wahl.',
      ctaButtonText: 'Vertrauliche Anfrage',
    },
    pageMethoden: {
      heroTitle: 'Unser Vorgehen',
      heroSubtitle: 'Diskret, ganzheitlich, langfristig',
      introText: 'Wir nehmen uns Zeit für Ihre Situation. Jedes Mandat beginnt mit einem persönlichen Gespräch und einer umfassenden Analyse.',
      steps: [
        { title: 'Analyse', description: 'Umfassende Erfassung Ihrer Vermögens- und Steuersituation' },
        { title: 'Strategie', description: 'Entwicklung einer individuellen Gesamtstrategie' },
        { title: 'Umsetzung', description: 'Koordination aller Massnahmen mit Ihren Beratern und Institutionen' },
        { title: 'Begleitung', description: 'Laufende Betreuung, jährliche Reviews, proaktive Anpassungen' },
      ],
      tools: [
        { name: 'Sichere Kommunikation', description: 'Verschlüsselte Korrespondenz und Dokumentenablage' },
        { name: 'Vermögens-Cockpit', description: 'Übersicht über alle Vermögenswerte und Steuerfolgen' },
        { name: 'Experten-Netzwerk', description: 'Zugang zu Spezialisten für Recht, Immobilien und Finanzen' },
      ],
      philosophyTitle: 'Unsere Werte',
      philosophyText: 'Absolute Diskretion, höchste Kompetenz und eine langfristige Perspektive — das ist unser Versprechen an Sie.',
    },
    pageUeberMich: {
      heroTitle: 'Unser Team',
      heroSubtitle: 'Erfahrene Berater für anspruchsvolle Mandate',
      introText: 'Unser Team vereint jahrzehntelange Erfahrung in Vermögensberatung, Steuerrecht und Nachlassplanung.',
      imageUrl: '',
      timeline: [
        { year: '1995', text: 'Gründung mit Fokus auf Privatmandate' },
        { year: '2008', text: 'Erweiterung um internationale Steuerberatung' },
        { year: '2020', text: 'Digitalisierung bei voller Diskretion' },
      ],
      values: [
        { title: 'Diskretion', description: 'Was Sie uns anvertrauen, bleibt vertraulich — ohne Ausnahme' },
        { title: 'Ganzheitlichkeit', description: 'Wir betrachten Ihre gesamte finanzielle Situation' },
        { title: 'Langfristigkeit', description: 'Generationenübergreifende Beratung und Planung' },
      ],
      certifications: 'EXPERTsuisse, Certified Tax Expert, STEP (Nachlassplanung)',
    },
  },
  components: {
    header: {
      companyName: 'Treuhand Muster AG',
      logoText: 'TM',
      navItems: ['Leistungen', 'Methoden', 'Team', 'Kontakt'],
      ctaText: 'Vertrauliche Anfrage',
    },
    hero: {
      title: 'Diskret. Ganzheitlich. Langfristig.',
      subtitle:
        'Steuern, Struktur, Nachfolge – mit einem Ansprechpartner und klarer Dokumentation.',
      primaryBtn: 'Vertrauliches Gespräch',
      secondaryBtn: 'Leistungen',
      imageUrl: '',
    },
    services: {
      title: 'Leistungen für Privatpersonen',
      subtitle: 'Wenn Komplexität Disziplin braucht.',
      items: [
        {
          icon: '🧾',
          title: 'Steuern',
          text: 'Erklärung, Planung, Optimierung – sauber dokumentiert.',
        },
        {
          icon: '🧱',
          title: 'Strukturen',
          text: 'Vermögens- und Gesellschaftsstrukturen – nachvollziehbar und robust.',
        },
        {
          icon: '🧬',
          title: 'Nachfolge',
          text: 'Vorsorge und Übergaben – proaktiv geplant.',
        },
      ],
    },
    team: {
      title: 'Ihre Berater',
      subtitle: 'Erfahrene Spezialisten für komplexe Privatmandate.',
      members: [
        {
          name: 'Dr. Stefan Waldmann',
          role: 'Partner & Steuerexperte',
          image: '',
          bio: 'Über 25 Jahre Erfahrung in der Steuerberatung für vermögende Privatpersonen. Spezialisiert auf internationale Steuerplanung und Nachfolgelösungen.',
        },
        {
          name: 'Christine Lehmann',
          role: 'Nachlassplanung & Vermögensstrukturierung',
          image: '',
          bio: 'Certified Tax Expert mit Fokus auf Erbschaftsplanung, Stiftungsgründung und generationenübergreifende Vermögensstrategien.',
        },
      ],
    },
    testimonials: {
      title: 'Vertrauen unserer Mandanten',
      items: [
        {
          quote: 'Eine Beratung, die weit über Steuern hinausgeht. Wir fühlen uns in allen finanziellen Fragen bestens aufgehoben.',
          author: 'Familie W.',
          role: 'Privatmandat seit 2012',
        },
        {
          quote: 'Die Nachlassplanung wurde mit grossem Feingefühl und Kompetenz umgesetzt. Vielen Dank.',
          author: 'H. Baumann',
          role: 'Unternehmer im Ruhestand',
        },
        {
          quote: 'Absolute Diskretion und Erreichbarkeit — genau das, was man bei sensiblen Finanzfragen erwartet.',
          author: 'Dr. R. Meier',
          role: 'Privatmandat, Zürich',
        },
        {
          quote: 'Dank der vorausschauenden Steuerplanung konnten wir erhebliche Einsparungen erzielen. Äusserst professionell.',
          author: 'M. und C. Sommer',
          role: 'Ehepaar, Vermögensmandat',
        },
      ],
    },
    faq: {
      title: 'Häufige Fragen',
      subtitle: 'Vertraulich und verständlich beantwortet.',
      items: [
        {
          question: 'Wie ist die Vertraulichkeit gewährleistet?',
          answer:
            'Wir unterliegen dem gesetzlichen Berufsgeheimnis und arbeiten ausschliesslich mit verschlüsselter Kommunikation. Alle Daten werden in der Schweiz gespeichert.',
        },
        {
          question: 'Ab welchem Vermögen lohnt sich eine professionelle Beratung?',
          answer:
            'Eine individuelle Steuer- und Vermögensberatung lohnt sich bereits ab einem Vermögen von CHF 500\'000. Je komplexer die Situation, desto grösser das Optimierungspotenzial.',
        },
        {
          question: 'Bieten Sie auch internationale Steuerberatung an?',
          answer:
            'Ja. Wir beraten bei grenzüberschreitenden Sachverhalten, Wegzugsbesteuerung und Doppelbesteuerungsabkommen. Bei Bedarf arbeiten wir mit spezialisierten Partnern im Ausland zusammen.',
        },
      ],
    },
  },
});
